import { render, staticRenderFns } from "./drewcla.vue?vue&type=template&id=6224a8db&"
import script from "./drewcla.vue?vue&type=script&lang=js&"
export * from "./drewcla.vue?vue&type=script&lang=js&"
import style0 from "./drewcla.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports